import { cn } from '../cn.ts';
import type { MockListRow } from './types.ts';

export interface MockRowListProps {
  readonly rows: readonly MockListRow[];
}

const TONE = {
  done: 'text-success-fg',
  running: 'text-warn-fg',
  idle: 'text-ink-600',
} as const;

/**
 * List hàng có thụt cấp — hộ dùng duy nhất hiện nay là WBS của `#pm`.
 *
 * KHÔNG hứa hộ dùng thứ hai ở đây. Bản đầu ghi là `#knowledge` sẽ dùng lại ở lô C; lô C đo chữ ký
 * thật và không phủ được: component này vẽ mỗi hàng thành CARD CÓ VIỀN với mã mono + nhãn đậm +
 * đuôi màu theo TRẠNG THÁI, còn hàng `#knowledge` là hàng TRẦN, dẫn đầu bằng huy hiệu có tint hoặc
 * icon, nhãn thường, đuôi màu cố định — `MockListRow` không có trường nào cho tint lẫn icon. Hộ
 * dùng thứ hai được dự đoán trước đó (`#collab`) cũng đã trượt. Một lời hứa như vậy làm lô sau tin
 * rồi mất một vòng; chốt API khi có hộ dùng thật, không trước.
 *
 * Thụt lề dưới `sm` còn một nửa: 34px trên màn 360px ăn gần 10% bề rộng cho một mức phân cấp,
 * và WBS có tới hai mức.
 *
 * Khoá của mỗi hàng ghép `code` với `label` vì `code` là tuỳ chọn — hai hàng không mã mà trùng
 * nhãn sẽ trùng khoá, và React im lặng render sai thứ tự khi danh sách đổi.
 */
export function MockRowList({ rows }: MockRowListProps) {
  return (
    <div className="flex flex-col gap-[9px] text-body-sm leading-[normal]">
      {rows.map((row) => (
        <div
          key={`${row.code ?? ''}-${row.label}`}
          className={cn(
            'flex items-center gap-3 rounded-field border bg-surface px-3.5 py-[11px]',
            'transition [transition-duration:var(--duration-hover)]',
            // Hover LOẠI TRỪ hàng đang chọn: bóng của hàng đang chọn là DẤU HIỆU "đang chọn",
            // dùng lại nó cho hover mọi hàng làm nhoè chính dấu hiệu đó.
            row.active === true
              ? 'border-brand-200 shadow-row-active'
              : 'border-ink-100 hover:border-brand-200 hover:shadow-row-active',
            row.level === 1 && 'ml-4 sm:ml-[34px]',
          )}
        >
          {row.code !== undefined && (
            <span
              className={cn(
                'font-mono text-eyebrow font-bold',
                row.level === 1 ? 'text-ink-400' : 'text-brand-600',
              )}
            >
              {row.code}
            </span>
          )}

          <span className={cn(row.level !== 1 && 'font-semibold')}>{row.label}</span>

          {row.trailing !== undefined && (
            <span className={cn('ml-auto text-eyebrow font-bold', TONE[row.tone ?? 'idle'])}>
              {row.trailing}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
